// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-dele-socios {\r\n  font-size: 14px;\r\n  padding: 8px !important;\n}\n.aling_midle {\r\n  vertical-align: middle!important;\n}\r\n", ""]);
// Exports
module.exports = exports;
